import React from 'react';
import Class10Results2026 from '../views/Class10Results2026/Class10Results2026';


const ClassAssembly11CPage = () => {
    return <Class10Results2026 />;
  };
  
  export default ClassAssembly11CPage;
